<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <div
      @click="(category.title.length > 0) && ('count' in category && (category.count > 0)) && close()"
      class="fixed inset-0 transition-opacity"
    >
      <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
    </div>

    <form
      @submit.prevent="close()"
      class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
    >
      <div class="mt-3 text-center sm:mt-0 sm:text-left">
        <h3 class="text-lg leading-6 text-gray-900">Kategorie bearbeiten</h3>
        <div class="mt-6 grid grid-cols-1 row-gap-6 col-gap-4 sm:grid-cols-6">
          <basic-input
            class="sm:col-span-3"
            v-model="category.title"
            label="Name"
            placeholder="Freie Platzwahl"
          />

          <basic-input
            v-if="'count' in category"
            v-model="category.count"
            class="sm:col-span-3"
            label="Kontingent"
            placeholder="100"
            type="number"
          />

          <basic-input
            v-else-if="category.defaultContingent"
            disabled
            :value="category.defaultContingent.count"
            class="sm:col-span-3"
            label="Kontingent"
            placeholder="100"
            type="number"
          >
            <template v-slot:cornerHint>
              <button
                @click="editContingent"
                class="text-sm text-blue-500 underline flex items-center"
              >
                Bearbeiten
                <font-awesome-icon class="ml-1" icon="external-link" />
              </button>
            </template>
          </basic-input>
        </div>
      </div>
      <div class="mt-5 sm:flex">
        <basic-button
          class="w-full sm:w-auto"
          button-class="w-full justify-center"
          :disabled="!(category.title.length > 0) || ('count' in category && !(category.count > 0))"
          type="submit"
          color="white"
        >Schließen</basic-button>
        <basic-button
          design="secondary"
          class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-3 sm:w-auto"
          button-class="w-full justify-center"
          @click="destroy()"
          :disabled="category.types.length > 0"
          color="red"
          leading-icon="trash"
        >Löschen</basic-button>
      </div>
    </form>
  </div>
</template>


<script>
export default {
  props: {
    categoryProp: {
      required: true,
      type: Object
    },
    destroyFunc: {
      required: true,
      type: Function
    },
    editContingentFunc: {
      required: true,
      type: Function
    }
  },

  data() {
    return {
      category: this.categoryProp
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    destroy() {
      this.close();

      return this.destroyFunc();
    },
    editContingent() {
      this.close();

      return this.editContingentFunc();
    }
  }
};
</script>